/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archivedonemessage2Inputs */



/**
* | output |
* | --- |
* | "Contact moved to the archive" |
*
* @param {Archivedonemessage2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const archivedonemessage2 = /** @type {((inputs?: Archivedonemessage2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archivedonemessage2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Contact moved to the archive")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contacto movido al archivo")
	return /** @type {LocalizedString} */ ("Контакт отправлен в архив")
});
export { archivedonemessage2 as "archiveDoneMessage" }